import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IPostInput,
    IPostResponse,
    IBankAccountClient,
} from 'interfaceAdapter/gatewaySchemas/IBankAccountClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class BankAccountClient implements IBankAccountClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token } = input;
        const PATH = `${API_LOCATION_URL}/supporter/bank_accounts`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }

    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, ...bodyData } = input;
        const PATH = `${API_LOCATION_URL}/supporter/bank_accounts`;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        const body = JSON.stringify(bodyData);
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
